<template>
  <header class="navbar-header">
    <div class="top-message" v-if="false">
      <div class="container">
        <div class="left-message">您好！欢迎访问十三五计划展示网页。</div>
        <div class="right-link">
          <ul>
            <li>登录</li>
            <li><span class="separator">|</span></li>
            <li>注册</li>
          </ul>
        </div>
      </div>
    </div>
    <div :class="headerBarFixed == true ? 'isFixed' : 'isInFixed' ">
    <div class="first-br-box">
      <div class="first-br">
        <!--项目logo以及名称显示-->
        <div class="logo-wrap">
          <router-link to="/">
            <img src="../../assets/images/home/logo@2x.png"/>
          </router-link>
        </div>
        <!--搜索输入内容-->
        <div class="right-search-content">
          <div class="">
            <searchList :searchNavValue='searchValue' ref="search" v-show="false"/>
            <div class="nav-search-box">
              <div class="nav">
                <span :class="{active: searchType==='项目'}" @click="changeSearchType('项目')">项目</span>
                <span :class="{active: searchType==='成果'}" @click="changeSearchType('成果')">成果</span>
<!--                <span :class="{active: searchType==='认证认可'}" @click="changeSearchType('认证认可')">认证认可</span>-->
<!--                <span :class="{active: searchType==='检验检测'}" @click="changeSearchType('检验检测')">检验检测</span>-->
              </div>
              <div class="search-input">
                <input v-model="searchValue" type="text" placeholder="搜索相关内容"/>
                <span @click="handleSearch" class="btn"><i class="fa fa-search"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="nav-bar-hidden">
      <div class="container">
        <label class="left-title">
          <router-link to="/"><img src="../../assets/images/home/logo@2x.png" height="40"/></router-link>
        </label>
        <ul>
          <template v-for="(item, index) in navList">
            <li :key="index" v-if="index !== 0"><span class="separator">|</span></li>
            <li @click="goCommonList(item.name)" :key="'mini' + item.name + index" :class="{'active': item.name === name, 'disabled': !item.name}">
              <router-link :to="item.url">{{item.name}}</router-link>
            </li>
          </template>
        </ul>
      </div>
    </div> -->
    <div class="upper-link">
      <div class="container">
        <ul>
          <template v-for="(item, index) in navList">
            <li
              :key="'menu' + item.url + index"
              :class="{active: item.url === $route.path}"
              @click="goCommonList(item)"
            >
              <div class="text">
                {{item.name}}
              </div>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
  </header>
</template>

<script>
import searchList from '@/components/searchList'
export default {
  name: 'topNav',
  components: {
    searchList
  },
  data () {
    return {
      navList: [
        {
          name: '首页',
          url: '/dashboard'
        },
        {
          name: '数说NQI',
          url: '/dataAssemble'
        },
        {
          name: '新闻动态',
          url: '/newsTrends'
        },
        {
          name: '成果荟萃',
          url: '/achievements'
        },
        {
          name: '项目风采',
          url: '/project'
        },
        {
          name: '一站式查询',
          url: '/oneStep'
        },
        {
          name: '关于我们',
          url: '/introduction'
        }
      ],
      name: '首页',
      searchType: '项目',
      searchValue: '',
      bulletMessage: {},
      timer: null,
      stop: false,
      left: 0,
      headerBarFixed: false
    };
  },
  created () {
  },
  mounted () {
    $(document).scroll(function (event) {
      if ($(document).scrollTop() > 100) {
        $('.nav-bar-hidden').addClass('nav_fix')
      } else {
        $('.nav-bar-hidden').removeClass('nav_fix')
      }
    });
    window.addEventListener('scroll', this.handleScroll)
    // this.fetch('/sys/sysNotice/proclamation').then(res => {
    //   this.bulletMessage = res.data;
    //   this.$nextTick(function () {
    //     $('#rollSpan').html('《' + this.bulletMessage.title + '》' + $('#bulletContent').text());
    //     this.stopAnimate();
    //     this.animateLeft();
    //   })
    // });
  },
  methods: {
    handleScroll () {
      if ($(document).scrollTop() > 0) {
        this.headerBarFixed = true
      } else {
        this.headerBarFixed = false
      }
    },
    goCommonList (item) {
      this.name = item.name
      this.$router.push(item.url)
      // if (name === '政策法规') {
      //   name = '法律'
      //   this.$store.commit('saveMultipleValue', name)
      // }
      // if (name === '新闻动态') {
      //   this.$store.commit('saveMultipleValue', '要闻')
      // }
      // 初始化mul头部
      // this.$store.commit('saveNormalListDataPage',
      //   {currPage: 1, pageSize: 10}
      // )
      // this.$store.commit('saveHotListData', [])
      // localStorage.setItem('filterValue', name)
      // this.$store.commit('saveFilterValue')
    },
    pushCommonList (obj) {
      this.$store.commit('saveNormalList', [])
      localStorage.setItem('filterValue', obj.name)
      this.$store.commit('saveFilterValue')
      this.$store.commit('saveIsHot', false)
      this.$store.commit('saveIsTopNav', false)
      // window.open('/')
      this.$router.push({ path: '/commonList' })
      this.$store.commit('saveMultipleValue', obj.level)
      this.$store.commit('saveIsSliderNav', true)
    },
    animateLeft () {
      const _self = this;
      _self.stop = false;
      _self.timer = setInterval(function () {
        $('#rollSpan').css('margin-left', _self.left + 'px');
        if ($('#rollSpan').width() / 2 + _self.left <= 0) _self.left = $('#rollSpan').width() / 2 + _self.left;
        _self.left = _self.left - 1;
      }, 100);
    },
    stopAnimate () {
      this.stop = true;
      if (this.timer) clearInterval(this.timer);
    },
    toHome (item) {
      if (item === '首页') {
        localStorage.setItem('filterValue', '计量')
        this.$store.commit('saveFilterValue')
      }
    },
    handleSearch () {
      if (this.searchType === '成果') {
        this.$router.push({path: '/canonical', query: {keyWords: this.searchValue}});
      } else {
        this.$router.push({path: '/project', query: {keyWords: this.searchValue}});
      }
      // this.$store.commit('saveActiveShow', '')
      // this.$store.commit('saveIsSliderNav', false)
      // this.$store.commit('saveIsTopNav', true)
      // this.$store.commit('saveMultipleValue', '')
      // localStorage.setItem('filterValue', this.searchType)
      // this.$store.commit('saveFilterValue', this.searchType)
      // this.$refs.search.changeValue()
    },
    changeSearchType (type) {
      if (this.searchType === type) return;
      this.searchType = type;
    }
  },
  computed: {
    path () {
      return this.$route.path;
    }
  },
  watch: {},
  destroyed () {
    this.stopAnimate();
    window.removeEventListener('scroll', this.handleScroll)
  }
};
</script>

<style lang="less" scoped>
.navbar-header {
  background-color: #fff;
  width: 100%;
  .isFixed{
      position: fixed;
      top:0;
      width: 100%;
      z-index: 99;
  }
  .isInFixed{
      position: fixed;
      top:40;
      width: 100%;
      z-index: 99;
  }
  .top-message {
    position: relative;
    z-index: 30;
    height: 40px;
    font-size: 12px;
    color: #7d7d7d;
    background: #f5f5f5;
    .container {
      margin: 0 auto;
      width: @body-width;
      .left-message {
        float: left;
        line-height: 40px;
      }
      .right-link {
        float: right;
        ul {
          li {
            float: left;
            line-height: 40px;
            padding: 0 5px;
            a {
              text-align: center;
              color: #7d7d7d;
              display: inline-block;
              &:hover {
                color: @color-base;
                text-decoration: none;
              }
              .fa {
                margin: 0 4px;
              }
            }
            .separator {
              color: #424242;
            }
          }
        }
      }
    }
  }
  .first-br-box {
    width: 100%;
    height: 120px;
    border: 1px solid #2E5C9A;
    background: linear-gradient(180deg, #095791 0%, #337EC2 100%);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  }
  .first-br {
    display: flex;
    height: 120px;
    margin: 0 auto;
    width: @body-width;
    justify-content: space-between;
    .logo-wrap {
      display: inline-block;
      img {
        margin-top: 31px;
        width: 358px;
        height: 56px;
      }
    }
    .right-search-content {
      display: flex;
      flex-direction: column;
      // width: 400px;
      position: relative;
      .nav-search-box {
        position: absolute;
        top: 30px;
        right: 0;
      }
      .nav {
        span {
          border-radius: 2px 2px 0 0;
          cursor: pointer;
          display: inline-block;
          width: 60px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          font-family: PingFangSC-Regular, PingFang SC;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.65);
          transition: all .5s;
          &.active {
            background-color: rgba(255, 255, 255, 0.15);
            border-radius: 2px 2px 0px 0px;
          }
        }
      }
      .search-input {
        display: flex;
        input {
          color: #ffffff;
          width: 320px;
          height: 40px;
          line-height: 40px;
          flex: 1;
          text-indent: 16px;
          border: 1px solid rgba(255, 255, 255, 0.15);
          background-color: transparent;
          &::-webkit-input-placeholder { color:rgba(255, 255, 255, 0.65); }
          &::-moz-placeholder { color:rgba(255, 255, 255, 0.65); } /* firefox 19+ */
          &:-ms-input-placeholder { color:rgba(255, 255, 255, 0.65); } /* ie */
          &:-moz-placeholder { color:rgba(255, 255, 255, 0.65); }
        }
        .btn {
          background-color: rgba(255, 255, 255, 0.15);
          border-radius: 0;
          color: #ffffff;
          font-size: 16px;
          height: 40px;
          line-height: 25px;
          width: 40px;
        }
      }
    }
    .right-menu {
      line-height: 82px;
      float: right;
      display: inline-block;
      ul {
        float: right;
        margin-top: 18px;
        transition: all .3s;
        li {
          display: inline-block;
          text-align: center;
          line-height: 25px;
          font-size: 16px;
          font-weight:bold;
          margin-left: 40px;
          &:first-child {
            margin-left: 0;
          }
          a {
            color: rgba(0, 0, 0, 0.84);
            text-decoration: none;
          }
        }
        .active {
          a {
            color: @color-blue;
          }
        }
        li:hover {
          a {
            color: @color-blue;
          }
        }
      }
    }
  }
  .nav-bar-hidden {
    background: #fff;
    position: fixed;
    top: -10px;
    left: 0;
    z-index: 99;
    height: 60px;
    width: 100%;
    margin-top: -60px;
    -webkit-transition: margin-top .3s linear;
    transition: margin-top .3s linear;
    -webkit-box-shadow: none;
    box-shadow: none;
    border-top: 1px solid #e0e0e0;
    &.nav_fix {
      top: 0;
      margin-top: 0;
      border-bottom: 1px solid #e0e0e0;
      -webkit-box-shadow: 0 5px 5px rgba(0,0,0,.07);
      box-shadow: 0 5px 5px rgba(0,0,0,.07);
    }
    .container {
      margin: 0 auto;
      padding: 0;
      width: @body-width;
      .left-title {
        img {
          margin-top: 10px;
        }
      }
      ul {
        float: right;
        margin: 17px 0 0 0;
        li {
          float: left;
          margin: 0 .5em;
          &.active {
            a {
              color: @color-base;
              font-weight: bold;
              text-decoration: none;
            }
          }
          a {
            color: #616161;
            &:hover {
              color: @color-base;
              text-decoration: none;
            }
          }
          &.disabled {
            a {
              cursor: no-drop;
              color: #999999;
            }
          }
          .separator {
            color: #e0e0e0;
          }
        }
      }
    }
  }
  .upper-link {
    margin-bottom: 2px;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, .1);
    background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
    .container {
      margin: 0 auto;
      padding: 0;
      position: relative;
      width: @body-width;
      background-color: #fff;
      li {
        cursor: pointer;
        color: #616161;
        float: left;
        width: 143px;
        height: 50px;
        line-height: 50px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-size: 18px;
        font-weight: bold;
        color: #136BAE;
        cursor: pointer;
        &:first-child {
          width: 114px;
        }
        .text {
          display: inline-block;
          width: 100%;
          height: 18px;
          line-height: 18px;
          text-align: center;
          border-right: 1px solid rgba(46, 92, 154, 0.3);
        }
        .text {
          text-decoration: none;
          &:hover {
            color: @color-base;
            text-decoration: none;
          }
        }
        &.active {
          background-color: rgba(19, 107, 174, 1);
          .text {
            font-weight: bold;
            color: #fff;
            text-decoration: none;
          }
        }
        &:hover, &:focus {
          border: 0 none;
          outline: 0 none;
        }
        &.disabled {
          .text {
            cursor: no-drop;
            color: #999999;
          }
        }
        .separator {
          color: #e0e0e0;
          margin: 0 15px;
        }
      }
      .message-roll {
        position: absolute;
        right: 0;
        width: 400px;
        line-height: 60px;
        height: 60px;
        .fa {
          font-size: 16px;
          left: 0;
          line-height: 60px;
          position: absolute;
          width: 26px;
        }
        .inner-content {
          position: absolute;
          left: 26px;
          white-space: nowrap;
          overflow: hidden;
          right: 0;
        }
        .message-detail-box {
          background-color: #ffffff;
          border: 1px solid #bababa;
          border-radius: 0 0 4px 4px;
          position: absolute;
          left: 26px;
          right: 0;
          height: 300px;
          overflow: auto;
          z-index: 1000;
          line-height: 24px;
          padding: 10px;
          opacity: 0;
          top: 0;
          transition: all .3s;
          visibility: hidden;
          &.show {
            visibility: visible;
            opacity: 1;
            top: 60px;
          }
          .title {
            display: block;
            font-size: 16px;
            padding-bottom: 10px;
            border-bottom: 1px solid #bababa;
            text-align: center;
            .time {
              display: block;
              font-size: 12px;
              text-align: right;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/home/topNav.vue